import { render, staticRenderFns } from "./employees-new.vue?vue&type=template&id=75d5db00&scoped=true&"
import script from "./employees-new.vue?vue&type=script&lang=ts&"
export * from "./employees-new.vue?vue&type=script&lang=ts&"
import style0 from "./employees-new.vue?vue&type=style&index=0&id=75d5db00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d5db00",
  null
  
)

export default component.exports